// Splits a <mark>-tagged headline highlight ("<title> at <company>") into its title and company
// segments at the last " at " that lies outside any <mark> span, so a card can render the
// highlighted title followed by the company as its own (linked) element.
//
// Returns { title, company } as <mark>-tagged strings, or { title: markup, company: null } when the
// headline has no splittable " at " (render the whole thing as the title).

const SEPARATOR = " at ";

export default function splitHeadlineHighlight(markup) {
  if (typeof markup !== "string" || markup === "") return { title: "", company: null };

  let depth = 0;
  let lastSeparatorIndex = -1;

  for (let i = 0; i <= markup.length - SEPARATOR.length; i += 1) {
    if (markup.startsWith("<mark>", i)) depth += 1;
    else if (markup.startsWith("</mark>", i)) depth = Math.max(0, depth - 1);
    else if (depth === 0 && markup.startsWith(SEPARATOR, i)) lastSeparatorIndex = i;
  }

  if (lastSeparatorIndex === -1) return { title: markup, company: null };

  return {
    title: markup.slice(0, lastSeparatorIndex),
    company: markup.slice(lastSeparatorIndex + SEPARATOR.length),
  };
}
